class BrandsList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.determineActiveLetters()
  }

  setupListeners () {
    super.setupListeners()

    this.handleLetterClick = this.handleLetterClick.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleClear = this.handleClear.bind(this)

    this.els.letter.elements?.forEach((letterEl) => {
      this.listeners.add(letterEl, 'click', this.handleLetterClick)
    })

    if (this.els.input.element) {
      this.listeners.add(this.els.input.element, 'input', this.handleSearch)

      this.listeners.add(this.els.input.element, 'keydown', (event) => {
        if (event.key === 'Escape') this.handleClear()
      })
    }
  }

  determineActiveLetters () {
    this.els.letter.elements?.forEach((letterEl) => {
      const letter = letterEl.dataset.letter

      const matchingGroup = this.querySelector(
        `${this.els.group.selector}[data-letter="${letter}"]`,
      )

      if (!matchingGroup) {
        letterEl.setAttribute('disabled', '')
        letterEl.dataset.initialDisabled = true
      }
    })
  }

  handleLetterClick (event) {
    const clickedLetterEl = event.target.closest(this.els.letter?.selector)
    if (!clickedLetterEl) return

    this.els.group.elements?.forEach((groupEl) => {
      if (groupEl.dataset.letter === clickedLetterEl.dataset.letter) {
        groupEl.scrollIntoView({ behaviour: 'smooth', block: 'start' })
      }
    })
  }

  handleSearch () {
    const term = this.els.input.element?.value.trim().toLowerCase()

    const noResultsTitle = this.els.noResultsTitle.element
    const string = noResultsTitle?.dataset?.format?.replace('[query]', term)
    noResultsTitle.textContent = string

    if (!term) {
      this.handleClear()
      return
    }

    const lettersWithMatch = new Set()

    this.els.brand.elements?.forEach((brandEl) => {
      const text = (brandEl.textContent || '').toLowerCase()
      const matches = text.includes(term)
      const letter = brandEl.dataset.letter

      brandEl.parentElement.setAttribute('aria-hidden', !matches)

      if (matches) {
        lettersWithMatch.add(letter)
      }
    })

    this.dataset.hasMatches = Boolean(lettersWithMatch.size)
    this.dataset.hasSearched = true

    this.els.letter.elements?.forEach((letterEl) => {
      const letter = letterEl.dataset.letter
      let matches = lettersWithMatch.has(letter)

      if (
        this.dataset.hasMatches === 'false' &&
        letterEl.dataset.initialDisabled !== 'true'
      ) {
        matches = true
      }

      if (matches) {
        letterEl.removeAttribute('disabled')
      } else {
        letterEl.setAttribute('disabled', '')
      }
    })

    let firstChild = true

    this.els.group.elements?.forEach((groupEl) => {
      const letter = groupEl.dataset.letter
      const matches = lettersWithMatch.has(letter)

      if (matches && firstChild) {
        groupEl.dataset.firstChild = true
        firstChild = false
      } else {
        groupEl.dataset.firstChild = false
      }

      groupEl.setAttribute('aria-hidden', !matches)
    })
  }

  handleClear () {
    this.dataset.hasMatches = true
    this.dataset.hasSearched = false

    this.els.letter.elements?.forEach((letterEl) => {
      if (letterEl.dataset.initialDisabled) return
      letterEl.removeAttribute('disabled')
    })

    this.els.group.elements?.forEach((groupEl) => {
      groupEl.dataset.firstChild = false
      groupEl.setAttribute('aria-hidden', false)
    })

    this.els.brand.elements?.forEach((brandEl) => {
      brandEl.parentElement.setAttribute('aria-hidden', false)
    })

    this.els.input.element.value = ''
    this.els.input.element.focus()
  }
}

if (!customElements.get('brands-list')) {
  customElements.define('brands-list', BrandsList)
}
